import React from 'react'
import Point from './point'
import dataPoints from '../../data/points_data'

const Points = ({ p, size, selected, z }) => {
  let pointsFiltered
  let drawLanding = false
  let drawCapacity = false
  let drawPop = false
  let drawText = true
  let actualLayer = ''

  switch (selected.layer) {
    default:
      pointsFiltered = dataPoints
      drawPop = true
      drawLanding = true
      actualLayer = 'network'
      break
    case 'cables':
      pointsFiltered = dataPoints.filter(d => d.ls_cable || d.dot)
      drawLanding = true
      actualLayer = 'cables'
      break
    case 'ip':
      pointsFiltered = dataPoints.filter(d => d.internet)
      actualLayer = 'ip'
      drawPop = true
      break
    case 'colocation':
      pointsFiltered = dataPoints.filter(d => d.colocation)
      actualLayer = 'colocation'
      drawPop = true
      break
    case 'capacity':
      pointsFiltered = dataPoints.filter(d => d.capacity || d.dot)
      actualLayer = 'capacity'
      drawPop = true
      drawCapacity = true
      break
  }

  if (z < 600) drawText = false
  const mynumber = d => {
    let n
    switch (selected.layer) {
      default:
        n = 0
        break
      case 'ip':
        n = d.internet
        break
      case 'colocation':
        n = d.colocation
        break
      case 'capacity':
        n = d.capacity
        break
    }
    return n
  }
  const Po = pointsFiltered.map(d => {
    const x = p()([d.lon, d.lat])[0]
    const y = p()([d.lon, d.lat])[1]
    return (
      x > -10 &&
      y > -10 &&
      x < size.width + 10 &&
      y < size.height + 10 && (
        <Point
          key={'pop-g-' + d.id}
          x={x}
          y={y}
          d={d}
          nPoP={mynumber(d)}
          layer={actualLayer}
          draw={{
            pop: drawPop,
            text: selected.type === 'cable' ? false : drawText,
            ls: drawLanding,
            capacity: drawCapacity,
          }}
          s={selected.data.name === d.name}
        />
      )
    )
  })

  return <g className="Points">{Po}</g>
}


export default Points
